import { FC, ReactNode } from "react";
import styles from "./ContentContainer.module.css";

type ContentContainerProps = {
  children: ReactNode;
};

const ContentContainer: FC<ContentContainerProps> = ({ children }) => {
  return <div className={styles.contentContainer}>{children}</div>;
};

export default ContentContainer;
